export interface RouteValidationInputs {
  general: boolean;
  calculationModes: {
    tappingMode: boolean;
    ladleFurnaceMode: boolean;
  };
}

export interface RouteValidationResults {
  enableNewHeat: boolean;
  enableTappingMode: boolean;
  enableLadleFurnaceMode: boolean;
  shouldEnableTappingButton: boolean;
  shouldEnableLadleFurnaceButton: boolean;
}

export function calculateRouteValidations(input: RouteValidationInputs): RouteValidationResults {
  const enableNewHeat = input.general;
  const enableTappingMode = input.calculationModes.tappingMode;
  const enableLadleFurnaceMode = input.calculationModes.ladleFurnaceMode;

  const shouldEnableTappingButton = enableNewHeat && enableTappingMode;
  const shouldEnableLadleFurnaceButton = enableNewHeat && enableLadleFurnaceMode;

  return {
    enableNewHeat,
    enableTappingMode,
    enableLadleFurnaceMode,
    shouldEnableTappingButton,
    shouldEnableLadleFurnaceButton,
  };
}

